var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offer-travel-item tw-flex tw-items-center tw-justify-center"},[_c('ui-ctk-icon',{staticClass:"tw-mr-2",attrs:{"name":_vm.icon}}),_c('span',{domProps:{"textContent":_vm._s(_vm.label)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }